import React from 'react';
import { Button } from 'antd';

export const DangerButton = (props) => (
  <Button
    {...props}
    type='danger'
    className={`uppercase ${props.className}`}
  >
    {props.label}
  </Button>
);
